import { Box } from "@chakra-ui/react";
import {ReactComponent as CloseIcon} from '../../svg/closeIcon.svg'

export default function Tags({ keyword, removeTag }) {

    return (
        <Box
            d='flex'
            py={['0.25','0.5','1']}
            px={['2','3','4']}
            borderRadius='lg'
            border='1px solid #EED26E'
            bgColor='#FBF5DE'
            textTransform='capitalize'
            style={{ fontFamily: 'Mulish, sans-serif' }}
            fontWeight='600'
            fontSize={['12px', '14px', '16px', '16px']}
            m='1'
            justifyContent = 'center'
            alignItems = 'center'
        >
            {keyword}
            <CloseIcon onClick = {() => removeTag(keyword)} style ={{marginLeft:'1rem'}} cursor = 'pointer'/>
        </Box>
    )
}